<!--PRODUCTOS-->
<main *ngIf="productosService.vista == 'P'" class="mb-100">
  <section id="seccion-lista" class="seccion-lista">
    <div class="tarjeta-producto barra-busqueda-contenedor mb-3"
      [class.cargando]="busy" >
      <input type="text" class="campo-buscar" placeholder="Hola {{misdatos.first_name}}! añade un producto..."
        [(ngModel)]="productonuevo"
        (keyup.enter)="addProducto()">
      <button type="button" class="boton-anadir" 
        [disabled]="productonuevo.trim()==''"
        (click)="addProducto()"><i class="fa-solid fa-plus"></i></button>
      <div class="dropdown">
        <button type="button" class="boton-ordenar" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"
          ><i class="fa-solid fa-list-ol"></i></button>        
        <div class="dropdown-menu">
          <div class="list-group list-group-flush">
            <a class="pointer list-group-item list-group-item-action" (click)="ordenarPor('pr_orden')">
              <i class="fa-solid fa-list-ol text-secondary" [class.text-dark]="campoActual == 'pr_orden'"></i> Orden
              <span class="icono-orden" *ngIf="campoActual === 'pr_orden'">
                <i [ngClass]="esAscendente ? 'fa-solid fa-arrow-up-wide-short' : 'fa-solid fa-arrow-down-short-wide'"></i>
              </span>
            </a>
            <a class="pointer list-group-item list-group-item-action" (click)="ordenarPor('pr_fechahora_add')">
              <i class="fa-regular fa-calendar-days text-secondary" [class.text-dark]="campoActual == 'pr_fechahora_add'"></i> Fecha hora
              <span class="icono-orden" *ngIf="campoActual === 'pr_fechahora_add'">
                <i [ngClass]="esAscendente ? 'fa-solid fa-arrow-up-wide-short' : 'fa-solid fa-arrow-down-short-wide'"></i>
              </span>
            </a>
            <a class="pointer list-group-item list-group-item-action" (click)="ordenarPor('pr_producto')">
              <i class="fa-solid fa-text-height text-secondary" [class.text-dark]="campoActual == 'pr_producto'"></i> Título
              <span class="icono-orden" *ngIf="campoActual === 'pr_producto'">
                <i [ngClass]="esAscendente ? 'fa-solid fa-arrow-up-wide-short' : 'fa-solid fa-arrow-down-short-wide'"></i>
              </span>
            </a>
            <a class="pointer list-group-item list-group-item-action" (click)="ordenarPor('pr_id_user')">
              <i class="fa-regular fa-user text-secondary" [class.text-dark]="campoActual == 'pr_id_user'"></i> Usuario
              <span class="icono-orden" *ngIf="campoActual === 'pr_id_user'">
                <i [ngClass]="esAscendente ? 'fa-solid fa-arrow-up-wide-short' : 'fa-solid fa-arrow-down-short-wide'"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
      <div *ngIf="busy" class="spinner-contenedor">
        <div class="spinner-border text-principal" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
      </div>
    </div>
    <div cdkDropList (cdkDropListDropped)="ordenarProductos($event)">
      <article 
        *ngFor="let producto of productosNoCesta; trackBy: trackPorId" 
        [@desaparecer]
        cdkDrag> <div class="tarjeta-producto"
          [class.en-cesta]="producto.pr_check == 'X'" 
          [class.cargando]="producto.busy" 
          [class.activo]="producto === productoSeleccionado">
          
          <div class="bloque-izquierdo">
            <div (click)="checkProducto(producto)">
              <span class="control-seleccion"></span>
            </div>          
            <div>
              <app-inline-edit 
                  [modoEditar]="true"
                  [(ngModel)]="producto.pr_producto" 
                  inputClass="form-control fw-bold"
                  (ngModelChange)="guardarProducto(producto)">
                <h3 class="nombre-producto pointer">
                  <!--<span *ngIf="producto.esRepetido" class="small text-secondary"><i class="fa-solid fa-exclamation text-warning"></i></span>
                  <span *ngIf="producto.esAntiguo" class="small text-secondary"><i class="fa-solid fa-exclamation text-danger"></i></span>-->
                  {{producto.pr_producto}}
                </h3>
              </app-inline-edit>
              <div class="tiempo-registro">{{producto.pr_fechahora_add | cuandoFechas }}</div>
            </div>
          </div>        

          <div class="align-items-center fila-item">
            <div class="d-flex align-items-center">
              <div class="trash-btn me-3" (click)="$event.stopPropagation(); borrarProducto(producto)">
                <i class="fa-regular fa-trash-can"></i>
              </div>
              
              <div cdkDragHandle class="manejador-drag">
                <div *ngIf="producto.foto == ''" class="avatar-texto" [style.background-color]="producto.pr_color_brand">
                  {{producto.pr_first_brand}}
                </div>
                <img *ngIf="producto.foto != ''" class="avatar-usuario" [src]="producto.foto">
              </div>

            </div>
          </div>

          <div *ngIf="producto.busy" class="spinner-contenedor">
            <div class="spinner-border text-principal" role="status">
                <span class="visually-hidden">Cargando...</span>
            </div>
          </div>
        </div>

      </article>
    </div>
  </section>

  <section id="seccion-cesta" class="seccion-lista">
    <div class="d-flex justify-content-between">
      <div>
        <h2 class="titulo-lista">En la cesta · {{getProductosCheck('X').length}}</h2>
      </div>
      <div class="text-end">
        <span class="badge-carrito pointer" (click)="funciones.irAlMarcador('seccion-lista')"><i class="fa-solid fa-angle-up"></i></span>
      </div>
    </div>
    <article *ngFor="let producto of getProductosCheck('X'); trackBy: trackPorId" [@desaparecer]>
      <div class="tarjeta-producto" [class.en-cesta]="producto.pr_check == 'X'">
        <div class="bloque-izquierdo">
          <span class="control-seleccion" (click)="checkProducto(producto)"></span>
          <div>
            <app-inline-edit 
                [modoEditar]="true"
                [(ngModel)]="producto.pr_producto" 
                inputClass="form-control fw-bold"
                (ngModelChange)="guardarProducto(producto)">
              <h3 class="nombre-producto pointer">{{producto.pr_producto}}</h3>
            </app-inline-edit>
            <span class="tiempo-registro">{{producto.pr_fechahora_add | cuandoFechas }}</span>
          </div>
        </div>
        <div *ngIf="producto.foto == ''" class="avatar-texto" [style.background-color]="producto.pr_color_brand">{{producto.pr_first_brand}}</div>
        <img *ngIf="producto.foto != ''" class="avatar-usuario" [src]="producto.foto">
      </div>
    </article>
  </section>

  <section id="seccion-borrado" class="seccion-lista pb-2"
    *ngIf="getProductosBorrados().length > 0">
    <div class="d-flex justify-content-between">
      <div>
        <h2 class="titulo-lista">Últimos productos borrados</h2>
      </div>
      <div class="text-end">
        <span class="badge-carrito pointer" (click)="funciones.irAlMarcador('seccion-lista')"><i class="fa-solid fa-angle-up"></i></span>
      </div>
    </div>
    <article *ngFor="let producto of getProductosBorrados(); trackBy: trackPorId" [@desaparecer]>
      <div class="tarjeta-producto" 
        [class.cargando]="producto.busy" 
        [class.borrado]="producto.pr_borrado == 'X'">
        <div class="bloque-izquierdo">
          <span class="control-seleccion" (click)="recuperarProducto(producto)"><i class="fa-solid fa-rotate-left"></i></span>
          <div>
            <app-inline-edit 
                [modoEditar]="true"
                [(ngModel)]="producto.pr_producto" 
                inputClass="form-control fw-bold"
                (ngModelChange)="guardarProducto(producto)">
              <h3 class="nombre-producto pointer">{{producto.pr_producto}}</h3>
            </app-inline-edit>
            <span class="tiempo-registro">{{producto.pr_fechahora_add | cuandoFechas }}</span>
          </div>
        </div>
        <div class="align-items-center fila-item">
          <div class="d-flex align-items-center">
            <div class="trash-btn me-3" (click)="$event.stopPropagation(); borrarProducto(producto)">
              <i class="fa-regular fa-trash-can"></i>
            </div>
            <div *ngIf="producto.foto == ''" class="avatar-texto" [style.background-color]="producto.pr_color_brand">{{producto.pr_first_brand}}</div>
            <img *ngIf="producto.foto != ''" class="avatar-usuario" [src]="producto.foto">
          </div>
        </div>
        <div *ngIf="producto.busy" class="spinner-contenedor">
          <div class="spinner-border text-principal" role="status">
              <span class="visually-hidden">Cargando...</span>
          </div>
        </div>
      </div>
    </article>
  </section>
</main>

<!--COMPRAS-->
<main *ngIf="productosService.vista == 'C'" class="mb-100">
  <app-compras></app-compras>
</main>

<app-footer></app-footer>